/**
 * Concatenates first and last name into a full name
 * @param {string} firstName - First name
 * @param {string} lastName - Last name
 * @returns {string} Full name or 'N/A' if both are empty
 */
export const concatenateNames = (firstName, lastName) => {
  const fullName = `${firstName || ''} ${lastName || ''}`.trim();
  return fullName || 'N/A';
};

/**
 * Formats a date string for display
 * @param {string} dateString - ISO date string
 * @param {string} format - Date format (default: 'MMM dd, yyyy')
 * @returns {string} Formatted date or 'N/A' if invalid
 */
export const formatDate = (dateString, format = 'MMM dd, yyyy') => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
    
    // Simple date formatting - you can enhance this with date-fns if needed
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const day = date.getDate();
    const year = date.getFullYear();
    
    return `${month} ${day}, ${year}`;
  } catch (error) {
    return 'N/A';
  }
};

/**
 * Gets funder information from payload if JOIN fails
 * @param {Object} row - Outreach row data
 * @returns {Object} Funder information object
 */
export const getFunderInfo = (row) => {
  // Try to get funder info from JOIN first
  if (row.funder_name) {
    return {
      name: row.funder_name,
      website: row.funder_website,
      email: row.funder_email,
      strategy: row.funder_strategy,
      investment_amount: row.funder_investment_amount
    };
  }
  
  // Fallback to payload data if JOIN failed
  try {
    if (row.payload && typeof row.payload === 'object') {
      // Payload is already an object, no need to parse
      const payload = row.payload;
      if (payload.funder_payload) {
        return {
          name: payload.funder_payload.name || 'N/A',
          website: payload.funder_payload.website || 'N/A',
          email: payload.funder_payload.email || 'N/A',
          strategy: payload.funder_payload.thesis_text || 'N/A',
          investment_amount: payload.funder_payload.ticket_range ? 
            `$${payload.funder_payload.ticket_range[0].toLocaleString()} - $${payload.funder_payload.ticket_range[1].toLocaleString()}` : 'N/A'
        };
      }
    }
  } catch (error) {
    console.error('Error getting funder info from payload:', error);
  }
  
  // Default fallback
  return {
    name: 'N/A',
    website: 'N/A',
    email: 'N/A',
    strategy: 'N/A',
    investment_amount: 'N/A'
  };
};
